// extracted by mini-css-extract-plugin
export default {"arrow":"select-module--arrow--365e1","wrapper":"select-module--wrapper--03ece"};